import React, { ReactNode } from "react"
import Components from "../index"
import { blokType } from "../../types"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { StaticQuery, graphql } from "gatsby"
import {
  StyledCourse,
  StyledCourseProps,
  StyledCourseMain,
  StyledCourseLabel,
  StyledCourseTitle,
  StyledCourseDescription,
  StyledCoursePrograms,
  StyledCourseTopics,
} from "./partials"

export interface CourseTemplateProps extends StyledCourseProps {
  title: string
  description: string
  type: string
  degree: string
  programs: []
  module: string
  topics: blokType[]
  hide_programs: boolean
}

export const CourseTemplateCmp: React.FC<CourseTemplateProps> = ({
  title,
  description,
  type,
  degree,
  programs,
  topics,
  hide_programs,
}) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokDatasourceEntry(

          filter: { data_source: { regex: "/^course-/" } }
        ) { 
          edges {
            node {
              data_source
              name
              value
              dimension_value
              data_source_dimension
            }
          }
        }
      }
    `}
    render={(data) => {
      const sBdataSource = data.allStoryblokDatasourceEntry.edges
      const courseProgramDataSource = sBdataSource.filter((item) => item.node.data_source_dimension === 'path')
      return (
        <StyledCourse degree={degree}>
          <StyledCourseMain>
            <StyledCourseLabel>
              {type && (
                <p>
                  {sBdataSource.find((typeDs: any) => typeDs.node.value === type).node.name}
                </p>
              )}
            </StyledCourseLabel>
            {title && title !== "" && (
              <StyledCourseTitle>{title}</StyledCourseTitle>
            )}
            {description && description !== "" && (
              <StyledCourseDescription>
                {
                  unified()
                    .use(remarkParse)
                    .use(remarkRehype)
                    .use(rehypeReact as any, {
                      createElement: React.createElement,
                      components: remarkReactComponents,
                      Fragment: React.Fragment
                    })
                    .processSync(description).result as ReactNode
                }
              </StyledCourseDescription>
            )}
            {programs && programs.length > 0 && !hide_programs && (
              <StyledCoursePrograms programs_count={programs.length}>
                Included in&nbsp;
                {programs.map((p) => {
                  const program = courseProgramDataSource.find((programDs: any) => programDs.node.value === p)
                  if (program) {
                    return (
                      <span key={program.node.value}>
                        <a href={program.node.dimension_value}>{program.node.name}</a>
                      </span>
                    );
                  } else {
                    return <b key={p}></b>;
                  }
                })}
              </StyledCoursePrograms>
            )}
          </StyledCourseMain>
          {topics && topics.length > 0 && (
            <StyledCourseTopics>
              {topics.map((content: blokType) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </StyledCourseTopics>
          )}
        </StyledCourse>
      )
    }}
  />
)
